var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarBuyToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 0.71106H0.571429C0.255357 0.71106 0 0.966417 0 1.28249V12.7111C0 13.0271 0.255357 13.2825 0.571429 13.2825H15.4286C15.7446 13.2825 16 13.0271 16 12.7111V1.28249C16 0.966417 15.7446 0.71106 15.4286 0.71106ZM1.28571 1.99677H14.7143V4.13963H1.28571V1.99677ZM14.7143 11.9968H1.28571V5.71106H14.7143V11.9968ZM10.4821 10.8539H13.4286C13.5071 10.8539 13.5714 10.7896 13.5714 10.7111V9.42535C13.5714 9.34678 13.5071 9.28249 13.4286 9.28249H10.4821C10.4036 9.28249 10.3393 9.34678 10.3393 9.42535V10.7111C10.3393 10.7896 10.4036 10.8539 10.4821 10.8539Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBuyToken);
export default __webpack_public_path__ + "static/media/sidebar-buy-token.6179ab8fb5f34e4374b7e596169dea92.svg";
export { ForwardRef as ReactComponent };